import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { ScreenSize } from '../../../../enums';
import ResponsiveLayout from '../../Common/ResponsiveLayout/ResponsiveLayout';

export const Ul = styled.ul`
	align-items: flex-start;
	background-color: ${palette.mlcKoala};
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
	display: flex;
	flex: 1;
	flex-direction: column;
	flex-wrap: no-wrap;
	justify-content: space-between;
	list-style: none;
	margin-bottom: 0;
	margin-top: 0;
	padding: 0;
	padding-left: 0;
	transition: all 0.5s linear;
`;

export const SubMenuContainer = styled.div`
	@media (max-width: ${ScreenSize.xSmall}) {
		left: 0;
		right: 0;
	}
`;

export const ResponsiveContainer = styled(ResponsiveLayout)`
	@media (max-width: ${ScreenSize.xSmall}) {
		left: 0 !important;
		right: 0 !important;
		width: 100% !important;
	}
`;
